import { getAdminBasePath, prefixAdminPath } from '../config/adminHost';

export const ADMIN_PATHS = {
  LOGIN: '/login',
  SETUP: '/paladin',
  MAGIC_LINK: '/magic-link',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  INVITE_ACCEPT: '/invite/accept',
  DASHBOARD: '/dashboard',
  SUPPORT: '/support',
  SUPPORT_LOGIN: '/support-login',
  SETTINGS: '/settings',
  TOOLS: '/tools',
  TOOLS_PURGE_COMPANY: '/tools/purge-company',
  TOOLS_PACKAGE_GRACE_TEST: '/tools/package-grace-period-test',
  DEMOS: '/demos',
  IMPERSONATION: '/impersonation',
  USERS: '/users',
  SIGNUPS: '/signups',
  APP_SETTINGS: '/app-settings',
  PACKAGES: '/packages',
  PACKAGES_NEW: '/packages/new',
  PAYMENTS_AUTHORIZE: '/payments/authorize',
  SMS_LOGS: '/sms-logs',
  CONTACT_SUBMISSIONS: '/contact-submissions',
  IMPERSONATION_LOGS: '/impersonation-logs',
  SPECIAL_ACCESS_INVITES: '/special-access/invites',
  CUSTOM_PLANS: '/custom-plans',
  PATCH_NOTES: '/patch-notes',
  ADMIN_MANAGEMENT_CREATE: '/admin-management/create',
  ADMIN_MANAGEMENT_INVITE_CREATE: '/admin-management/invite-create',
  ADMIN_MANAGEMENT_INVITES: '/admin-management/invites',
};

/** Router path for in-app navigation. */
export function adminPath(path = '/') {
  return prefixAdminPath(path);
}

export function adminUserPath(userId) {
  return adminPath(`/users/${userId}`);
}

export function adminCompanyPath(companyId) {
  return adminPath(`/companies/${companyId}`);
}

export function adminPackageEditPath(pkgOrRouteKey) {
  const segment = typeof pkgOrRouteKey === 'object' && pkgOrRouteKey !== null
    ? (String(pkgOrRouteKey.slug || '').trim() || pkgOrRouteKey.id)
    : pkgOrRouteKey;
  return adminPath(`/packages/${segment}/edit`);
}

export function adminSupportTicketPath(companyId, ticketId) {
  return adminPath(`/support/${companyId}/${ticketId}`);
}

export function normalizeAdminRoutePath(pathname) {
  if (typeof pathname !== 'string') return '/';
  const base = getAdminBasePath();
  if (base && (pathname === base || pathname.startsWith(`${base}/`))) {
    return pathname.slice(base.length) || '/';
  }
  return pathname;
}
